<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="panel">
        <div class="panel-hdr">
          <div class="w-100">
            <div class="row">
              <div class="col-lg-6 col-sm-12">
                <h1 class="subheader-title mb-lg-0">
                  <i class="subheader-icon fal fa-info"></i> Общая сводка
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-container show">
          <div class="panel-container show" v-if="loading">
            <div class="panel-content p-6 m-6">
              <content-placeholders :centered="true">
                <content-placeholders-text :lines="4" />
              </content-placeholders>
            </div>
          </div>
          <div class="panel-content" v-if="!loading">
            <div class="d-flex mb-1">
              <div class="flex-grow-1">
                <ComponentWidgetStatisticsChart color="blue" title="Активно" :text="tasksStatistics.active+' задач'"/>
                <ComponentWidgetStatisticsChart :color="tasksStatistics.pause > 0 ? 'orange' : ''" title="На паузе" :text="tasksStatistics.pause+' задач'"/>
                <ComponentWidgetStatisticsChart :color="tasksStatistics.error > 0 ? 'red' : ''" title="С ошибкой" :text="tasksStatistics.error+' задач'"/>
              </div>
              <div class="d-flex flex-wrap justify-content-end align-self-start" v-if="(tasksStatistics.active + tasksStatistics.pause) > 0">
                <div class="d-flex">
                  <ComponentWidgetUptimeChart title="сутки" :text="uptimeStatistics.day" :data="uptime.day"/>
                  <ComponentWidgetUptimeChart title="неделя" :text="uptimeStatistics.week" :data="uptime.week"/>
                </div>
                <div class="d-flex">
                  <ComponentWidgetUptimeChart title="месяц" :text="uptimeStatistics.month" :data="uptime.month"/>
                  <ComponentWidgetUptimeChart title="год" :text="uptimeStatistics.year" :data="uptime.year"/>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <div class="panel-tag mb-4">Последние события</div>
                <table class="table table-task-events m-0">
                  <thead>
                    <tr>
                      <th>Событие</th>
                      <th>Задача</th>
                      <th>Дата</th>
                      <th>Причина</th>
                    </tr>
                  </thead>
                  <tbody data-element="events">
                    <tr :data-id="event.id" v-for="event in events" :key="event.id">
                      <th :data-status="event.status" v-if="event.status == 'up'">
                        <span class="p-2 badge badge-success">
                          <i class="fal fa-long-arrow-up mr-2"></i> {{ event.status | uppercase }}
                        </span>
                      </th>
                      <th :data-status="event.status" v-if="event.status == 'down'">
                        <span class="p-2 badge badge-danger">
                          <i class="fal fa-long-arrow-up mr-2"></i> {{ event.status | uppercase }}
                        </span>
                      </th>
                      <td :data-task="event.task.id"><router-link :to="{name: 'tasks/statistics', params: {id: event.task.id}}">{{ event.task.name }}</router-link></td>
                      <td>{{ event.date }}</td>
                      <td v-if="event.status == 'up'">
                        код ответа
                        <button data-button="information" class="btn btn-link p-0 btn-information" v-if="event.content != ''" v-on:click="eventInfo(event)">#{{ event.code }}</button>
                        <span v-if="event.content == ''">#{{ event.code }}</span>
                      </td>
                      <td v-if="event.status == 'down'">
                        ошибка
                        <button data-button="information" class="btn btn-link p-0" v-on:click="eventInfo(event)">#{{ event.code }}</button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="events.length == 0">
                    <tr>
                      <td colspan="4">Информации нет</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ComponentEventInfo from '@/components/events/information.vue';
  import ComponentWidgetStatisticsChart from '@/components/widgets/statisticsChart.vue';
  import ComponentWidgetUptimeChart from '@/components/widgets/uptimeChart.vue';

  export default {
    metaInfo: {
      title: 'Сводка по всем заданиям',
    },
    components: {
      ComponentWidgetStatisticsChart,
      ComponentWidgetUptimeChart
    },
    computed: {
      uptime() {
        return {
          day:   this.uptimeStatistics.day*100+'/10000',
          week:  this.uptimeStatistics.week*100+'/10000',
          month: this.uptimeStatistics.month*100+'/10000',
          year:  this.uptimeStatistics.year*100+'/10000',
        }
      }
    },
    data() {
      return {
        // Индикатор загрузки
        loading: true,
        // Статистика
        uptimeStatistics: [],
        tasksStatistics: [],
        // Последние события
        events: [],
      }
    },
    methods: {
      eventInfo (event) {
        this.$modal.show(ComponentEventInfo, {event: event}, {minWidth: 700});
      },
      // Статистика по задачам
      taskStatisticsLoading()
      {
          // Получение информации по задачам
          this.$axios.get(process.env.VUE_APP_API_URL+'/v1/statistics/summary/tasks').then(response =>
          {
            this.tasksStatistics = response.data.data;
          });
      },
      // Статистика по времени работы
      uptimeStatisticsLoading()
      {
          // Получение информации по задачам
          this.$axios.get(process.env.VUE_APP_API_URL+'/v1/statistics/summary/uptime').then(response =>
          {
            this.uptimeStatistics = response.data.data;
          });
      },
      getEvents()
      {
        // Получение данных по событиям
        this.$axios.get(process.env.VUE_APP_API_URL+'/v1/events').then(response =>
        {
          this.events = response.data.data;

          // Получение данных по событиям
          this.loading = false;
        });
      },
    },
    // Подгрузка данных
    mounted () 
    {
      this.taskStatisticsLoading();
      this.uptimeStatisticsLoading();
      this.getEvents();

      this.interval = setInterval(function() {
         this.taskStatisticsLoading(); 
         this.uptimeStatisticsLoading(); 
      }.bind(this), 15000);
    },
    // Остановка обновления данных
    destroyed () 
    {
      clearInterval(this.interval);
    }
  }
</script>

<style>
  td[colspan="4"] {
    text-align: center;
  }
</style>